import { render } from "./Sample_Status.vue?vue&type=template&id=f49a2610&scoped=true"
import script from "./Sample_Status.vue?vue&type=script&lang=js"
export * from "./Sample_Status.vue?vue&type=script&lang=js"

import "./Sample_Status.vue?vue&type=style&index=0&id=f49a2610&lang=scss&scoped=true"
import "./Sample_Status.vue?vue&type=style&index=1&id=f49a2610&lang=css"

import exportComponent from "D:\\eclipse\\workSpaceIDEA\\BioTechLeague_HUIDU_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f49a2610"]])

export default __exports__